import { Injectable } from '@angular/core';

const STORAGE_KEY = 'selectedProduct';

@Injectable({
  providedIn: 'root'
})
export class ProductSelectionService {

  saveProduct(product: any): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(product));
  }

  getProduct(): any | null {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  }

  clearProduct(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}
